define([], function () {
	'use strict';

	/**
	 * Cookie
	 * Widget to simplify cookie management.
	 * @see {@link http://www.w3schools.com/js/js_cookies.asp}
	 * @exports cookie
	 */
	var cookie = {

		/**
		 * Sets a cookie.
		 * @param {String} cname - The name of the cookie.
		 * @param {String} cvalue - The value of the cookie.
		 * @param {Number} exdays - The number of days until the cookie should expire.
		 * @public
		 */
		setCookie: function (cname, cvalue, exdays) {
			var d = new Date(),
				expires;

			d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
			expires = 'expires=' + d.toUTCString();
			document.cookie = cname + '=' + cvalue + '; ' + expires;
		},


		/**
		 * Gets a cookie.
		 * @param {String} cname - The name of the cookie.
		 * @public
		 */
		getCookie: function (cname) {
			var name = cname + '=',
				ca = document.cookie.split(';');

			for (var i = 0; i < ca.length; i++) {
				var c = ca[i];
				while (c.charAt(0) === ' ') {
					c = c.substring(1);
				}
				if (c.indexOf(name) === 0) {
					return c.substring(name.length, c.length);
				}
			}

			return '';
		}
	};


	return cookie;
});


//////////////////
// WEBPACK FOOTER
// ./components/cookie/cookie.js
// module id = 11
// module chunks = 0